import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            priceInput: '',
            display: 1,
            password: '',
            productInput:'',
            seq: '',
        }
    },
    validators: {
        priceInput: function (value) {
            return Validator.value(value)
            .required('상품 금액을 입력해주세요.')
            .custom(() => {
                if(this.priceInput < 0) {
                    return '상품 금액은 0 보다 커야합니다.'
                }
            })
        },
        display: function (value) {
            return Validator.value(value)
        },
        productInput: function (value) {
            return Validator.value(value)
                .required('상품 명을 입력해주세요.')
        },
        password: function (value) {
            return Validator.value(value)
                .required('관리자 비밀번호를 입력해주세요.')
        },
        seq: function (value) {
            return Validator.value(value)
                .required('노출 순서를 입력해주세요.')
        },

    }
}
